import { ogImageMeta } from "@/lib/og-images";
import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, LegalSection } from "@/components/legal-layout";

export const Route = createFileRoute("/imprint")({
  head: () => ({
    meta: [
      { title: "Imprint — the Vibing Company®" },
      { name: "description", content: "Legal notice (Impressum) for the Vibing Company® per § 5 TMG." },
      { property: "og:title", content: "Imprint — the Vibing Company®" },
      ...ogImageMeta("imprint", "Share card: imprint"),
      { property: "og:description", content: "Legal notice (Impressum) for the Vibing Company® per § 5 TMG." },
    ],
    links: [{ rel: "canonical", href: "/imprint" }],
  }),
  component: ImprintPage,
});

function ImprintPage() {
  return (
    <LegalLayout kicker="02.IMPRINT" title="Imprint" updated="June 2026">
      <LegalSection label="LEGAL.NOTICE" title="Information per § 5 TMG">
        <p>
          The following details are provided in accordance with § 5 of the German Telemedia Act
          (Telemediengesetz, TMG).
        </p>
      </LegalSection>

      <LegalSection label="COMPANY.INFO" title="Operator">
        <p>the Vibing Company®</p>
        <p>Sole proprietorship of Jonathan Osburg</p>
      </LegalSection>

      <LegalSection label="CONTACT.DATA" title="Contact">
        <p>St.-Klara-Str. 7A</p>
        <p>82377 Penzberg</p>
        <p>Germany</p>
        <p className="pt-3">
          Email:{" "}
          <a href="mailto:jon@vibing.inc" className="underline">jon@vibing.inc</a>
        </p>
      </LegalSection>

      <LegalSection label="REGISTRATION.DATA" title="Registration & VAT">
        <p>
          Small business per § 19 UStG — VAT is not charged. No commercial register entry is
          required for this sole proprietorship.
        </p>
      </LegalSection>

      <LegalSection label="RESPONSIBLE.CONTENT" title="Responsible for content">
        <p>
          Responsible for content per § 18 Abs. 2 MStV: Jonathan Osburg, address as above.
        </p>
      </LegalSection>

      <LegalSection label="DISCLAIMER" title="Liability for content & links">
        <p>
          We carefully review the content of this website. As a service provider we are
          responsible for our own content per § 7 (1) TMG. Under §§ 8–10 TMG we are not obliged
          to monitor transmitted or stored third-party information. Our website may contain
          links to external sites; we have no influence on their content and accept no liability
          for them. The respective provider of the linked page is always responsible for its
          content.
        </p>
      </LegalSection>

      <LegalSection label="DISPUTE" title="EU online dispute resolution">
        <p>
          The European Commission provides a platform for online dispute resolution:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noreferrer noopener"
            className="underline"
          >
            ec.europa.eu/consumers/odr
          </a>
          . We are not obliged and not willing to participate in dispute resolution proceedings
          before a consumer arbitration board.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
